import React from 'react';
import { Alert } from "react-bootstrap";

/**
 * AlertBanner component displays a Bootstrap Alert banner with customizable variant and content.
 * @param {Object} props - Component props
 * @param {string} props.variant - The variant of the Alert banner (default: "warning")
 * @param {React.ReactNode} props.children - The content of the Alert banner
 * @returns {JSX.Element} - JSX element representing the AlertBanner component
 */
const AlertBanner = ({ children, variant = "warning" }) => (
    <Alert variant={variant} className="position-fixed text-center p-1 top-0 start-0 w-100 border-0 rounded-0" style={{ zIndex: 1 }}>
        {children}
    </Alert>
);

export default AlertBanner;
